<template>
  <div class="int-card-wrap" v-if="error">
    <VCard class="int-card">
      <VCardTitle class="int-title">
        <slot name="logo">
          <img
            class="int-logo mx-auto"
            src="../../assets/img/rabota/logo-rabota-huntica.svg"
            alt=""
          >
        </slot>
      </VCardTitle>
      <VCardText class="int-text">
        <template
          v-if="error === integrationsErrorType.USER_EXISTS"
        >
          <i18n path="emailIsBusy" for="integrations">
            <router-link to="/vacancies/integrations">
              {{ $t('integrations') }}
            </router-link>
          </i18n>
        </template>
        <template v-else>
          {{ errorText.text }}
        </template>
        <br><br>
        <slot name="btn">
          <VBtn
            v-if="btnData"
            :to="btnData.to"
            width="100%"
            max-width="16.75rem"
            depressed
            color="#1FC57F"
            class="int-btn mb-12"
          >
            {{ btnData.text }}
          </VBtn>
        </slot>
      </VCardText>
    </VCard>

    <div>
      <i18n path="mistake" for="support" class="int-bottom-text">
        <a target="_blank" :href="`mailto:${supportEmail}`">{{ $t('support') }}</a>
      </i18n>
    </div>
  </div>
</template>

<script>
import { integrationsErrorType } from '@/enums';
import { useI18n } from 'vue-i18n-composable';
import { computed } from '@vue/composition-api';
import { SUPPORT_EMAIL } from '@/helpers/constants';

export default {
  name: 'IntegrationsError',
  setup(_, { root }) {
    const { t } = useI18n();
    const { error, payload = '{}' } = root.$route.query;
    const errorPayload = JSON.parse(payload);
    return {
      btnData: computed(() => {
        switch (error) {
          case integrationsErrorType.UNEXPECTED_BEHAVIOR:
            return {
              text: t('authCompany'),
              to: '/',
            };
          case integrationsErrorType.AUTHENTICATION_REQUIRED:
            return {
              text: t('authCompany'),
              to: { name: 'dashboard' },
            };
          default:
            return null;
        }
      }),
      errorText: computed(() => {
        switch (error) {
          case integrationsErrorType.UNEXPECTED_BEHAVIOR:
            return {
              text: t('authCompany'),
            };
          case integrationsErrorType.AUTHENTICATION_REQUIRED:
            return {
              text: t('emailIsBusy', [errorPayload.integration.name, t('integrations')]),
            };
          case integrationsErrorType.ADMIN_AUTH_REQUIRED:
            return {
              text: t('adminAuthRequired', [errorPayload.company.name, errorPayload.integration.name]),
            };
          default:
            return null;
        }
      }),
      error,
      integrationsErrorType,
      supportEmail: SUPPORT_EMAIL,
    };
  },
};
</script>

<style scoped lang="scss">
  .int-card-wrap {
    max-width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    padding: 0 0.75rem;
  }
  .int-card.v-card {
    width: 39.5rem;
    max-width: 100%;
    padding: 2.375rem 0.75rem 2.5rem;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.04);
    border-radius: 0.625rem;
    margin-bottom: 1.25rem;
  }
  .int-title.v-card__title {
    margin-bottom: 2.0625rem;
  }
  .int-text.v-card__text {
    max-width: 31.125rem;
    line-height: 1.53;
    color: #091A35;
    margin: 0 auto 2.25rem;
  }
  .int-bottom-text {
    display: block;
    max-width: 25.75rem;
    font-size: 0.875rem;
    line-height: 1.43;
    color: #091A35;
    margin: 1.875rem auto 0 auto;
    a {
      color: #091A35;
      text-decoration: underline;
    }
  }

  @media screen and (max-width: 374px) {
    .int-card.v-card {
      padding: 1.75rem 0.75rem 0;
    }
    .int-text.v-card__text {
      font-size: 1rem;
      margin: 0 auto 1.875rem;
    }
    .int-bottom-text {
      max-width: 18rem;
      margin-top: 1rem;
    }
  }

</style>

<i18n locale="en" lang="yml">
  emailIsBusy: >-
    There is already a user with this email
    in our system. You can connect {0} through section {1}
  integrations: Integrations
  mistake: If you are sure you are seeing this message by mistake, contact {0}.
  support: technical support
  authCompany: Login
  goToPersonal: Go to your personal account
  adminAuthRequired: >-
    You are trying to set up integration with the company account {0},
    but for this action you must have administrator rights on {1}.
    Please contact your administrator to configure the integration.
</i18n>

<i18n locale="ru" lang="yml">
  emailIsBusy: >-
    Пользователь с такой электронной почтой уже есть
    в нашей системе. Вы можете подключить {0} через раздел {1}
  integrations: Интеграции
  mistake: Если вы уверены, что видите это сообщение по ошибке, обратитесь в {0}.
  support: техническую поддержку
  authCompany: Авторизоваться
  goToPersonal: Перейти в личный кабинет
  adminAuthRequired: >-
    Вы пытаетесь настроить интеграцию с аккаунтом компании {0},
    но для этого действия необходимо обладать правами администратора на {1}.
    Пожалуйста, обратитесь к администратору для настройки интеграции.
</i18n>
